<template lang="pug">
transition(name="fab-slide")
  .onboarding-banner(v-if="mostrar")
    img.onboarding-banner-icon(:src="icon", alt="")
    .onboarding-banner-content
      .onboarding-banner-title {{ info.titulo }}
      .onboarding-banner-desc {{ info.descricao }}
      button.onboarding-banner-help.onboarding-banner-help--blue(
        type="button"
        @click="oQueVerificar"
        :disabled="loading"
      )
        v-icon.mr-1(style="color:#90caf9!important", left, small) info_outline
        | O que verificar?
    .onboarding-banner-actions
      v-btn.onboarding-banner-btn(
        depressed, dark, color="#1D9A5A"
        @click="confirmar"
        :loading="loading"
      )
        v-icon.mr-2(left, small) check_circle_outline
        | Confirmar
      button.onboarding-banner-help(
        type="button"
        @click="precisoDeAjuda"
        :disabled="loading"
      )
        v-icon.mr-1(style="color:#ffb74d!important", left, small) help_outline
        | Preciso de ajuda
</template>

<script>
import icon from '@/assets/images/onBoardIcon.png';
import { contatoOnboarding, getEtapa } from '@/util/onboarding';

export default {
  props: {
    etapa: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      icon,
    };
  },
  watch: {
    mostrar(val) {
      document.body.classList.toggle('has-onboarding-fab', val);
    },
  },
  mounted() {
    if (this.mostrar) document.body.classList.add('has-onboarding-fab');
  },
  beforeDestroy() {
    document.body.classList.remove('has-onboarding-fab');
  },
  computed: {
    // O banner fica visível enquanto a etapa não for concluída, sem depender de
    // o parceiro ter clicado em "Entendi" no tutorial. Assim ele persiste ao
    // sair e voltar para a tela (o estado vem do onboarding, não da sessão).
    mostrar() {
      if (!this.$root.isOnboardingPendente) return false;
      const d = this.$root.onboardingData;
      if (!d) return false;
      return d[this.etapa] != 1;
    },
    info() {
      const etapa = getEtapa(this.etapa);
      return (etapa && etapa.banner) || { titulo: 'Etapa concluída?', descricao: 'Confirme que esta etapa está ok.' };
    },
  },
  methods: {
    abrirWhatsApp() {
      const whatsapp = contatoOnboarding(this.$root.onboardingData, this.$root.FIREBASE_REMOTE_CONFIG.WPP_SUPORTE).telefone;
      const nome = this.$root.estabelecimentoSelecionado
        ? `${this.$root.estabelecimentoSelecionado.nome} | ${this.$root.estabelecimentoSelecionado.id}`
        : '';
      const url = `https://api.whatsapp.com/send?phone=${whatsapp}&text=Ol%C3%A1%2C%20preciso%20de%20ajuda%20com%20o%20onboarding%20do%20estabelecimento%20${encodeURIComponent(nome)}`;
      window.open(url, '_blank');
    },
    oQueVerificar() {
      window.getApp.$emit('OPEN_TUTORIAL', this.etapa);
    },
    precisoDeAjuda() {
      this.abrirWhatsApp();
    },
    async confirmar() {
      this.loading = true;
      try {
        const resultado = await this.$root.atualizarEtapaOnboarding(this.etapa);
        if (resultado) {
          window.getApp.$emit('OPEN_ONBOARDING');
        }
      } catch (err) {
        window.getApp.$emit('APP_ALERT', {
          color: 'red',
          text: 'Não foi possível confirmar a etapa. Tente novamente.',
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.onboarding-banner {
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 5;
  background: #1e1e2e;
  border-radius: 24px 0 0 0;
  padding: 16px 20px 16px 100px;
  display: flex;
  align-items: center;
  gap: 16px;
  max-width: 520px;
  box-shadow: -4px -4px 24px rgba(0, 0, 0, 0.25);
}

.onboarding-banner-icon {
  position: absolute;
  left: -25px;
  bottom: 0px;
  width: 130px;
  height: 130px;
  object-fit: contain;
  pointer-events: none;
}

@media (max-width: 600px) {
  .onboarding-banner {
    padding-left: 20px;
  }
  .onboarding-banner-icon {
    display: none;
  }
}

.onboarding-banner-content {
  flex: 1;
  min-width: 0;
}

.onboarding-banner-actions {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.onboarding-banner-title {
  font-size: 14px;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 2px;
  font-family: 'Poppins', sans-serif;
}

.onboarding-banner-desc {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.65);
  line-height: 1.4;
}

.onboarding-banner-btn {
  flex-shrink: 0;
  border-radius: 12px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  font-size: 14px !important;
  height: 40px !important;
  padding: 0 16px !important;
  animation: pulseGreen 2s infinite ease-in-out;
}

@keyframes pulseGreen {
  0% {
    transform: scale(0.98);
    box-shadow: 0 0 0 0 rgba(29, 154, 90, 0.7);
  }
  70% {
      transform: scale(1);
      box-shadow: 0 0 0 10px rgba(29, 154, 90, 0);
  }
  100% {
      transform: scale(0.98);
      box-shadow: 0 0 0 0 rgba(29, 154, 90, 0);
  }
}

.onboarding-banner-help {
  border: 0;
  background: transparent;
  color: #ffb74d;
  padding: 0;
  display: inline-flex;
  align-items: center;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.onboarding-banner-help--blue {
  color: #90caf9;
  margin-top: 6px;
}

.onboarding-banner-help:disabled {
  opacity: 0.6;
  cursor: default;
}

.fab-slide-enter-active,
.fab-slide-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}
.fab-slide-enter,
.fab-slide-leave-to {
  transform: translateY(100%);
  opacity: 0;
}
</style>

<style lang="scss">
body.has-onboarding-fab .application--wrap .application--wrap {
  padding-bottom: 50px !important;
}
</style>
